{
  "id": "op-mock-123",
  "clubId": "club-user",
  "module": "STANDS",
  "fromLevel": 2,
  "toLevel": 3,
  "ruleSetVersion": 1,
  "quotedCost": 3500000.0,
  "economyOperationId": "eco-mock-123",
  "stadiumVersion": 1,
  "status": "REQUESTED",
  "requestedAt": "2026-10-12T12:00:00Z",
  "appliedAt": null,
  "version": 1
}
